import { useUiStore } from '../../../../store/uiStore';
import { classes, stylesheet } from 'typestyle';
import { Blue80, Gray100, Gray170, typeCompact14MediumProperties } from '@traceair/tds';
import { MissionWindowTab } from '../../../../consts/missionWindowTab';
import { DroneQIcon, UploadIcon } from '@traceair/webapp-icons';

const css = stylesheet({
  container: {
    display: 'flex',
    gap: 24,
    ...typeCompact14MediumProperties,
  },
  link: {
    display: 'flex',
    height: 30,
    paddingBottom: 6,
    gap: 4,
    color: Gray100,
    textDecoration: 'none',
    alignItems: 'center',
    borderBottom: `2px solid transparent`,
    marginBottom: -1,
  },
  linkActive: {
    $nest: {
      '&&': {
        borderBottom: `2px solid ${Blue80}`,
        color: Gray170,
      },
    },
  },
});

export const MissionWindowNav = () => {
  const { selectedMissionWindowTab, setSelectedMissionWindowTab } = useUiStore();

  const handleClick = (tab: MissionWindowTab) => {
    setSelectedMissionWindowTab(tab);
  };

  return (
    <nav className={css.container} data-intercom-target="MissionWindowNav">
      <a
        onClick={() => handleClick(MissionWindowTab.Upload)}
        className={classes(css.link, selectedMissionWindowTab === MissionWindowTab.Upload && css.linkActive)}
        href="#"
      >
        <UploadIcon size={20} color={selectedMissionWindowTab === MissionWindowTab.Upload ? Gray170 : Gray100} />
        {MissionWindowTab.Upload}
      </a>

      <a
        onClick={() => handleClick(MissionWindowTab.MissionInfo)}
        className={classes(css.link, selectedMissionWindowTab === MissionWindowTab.MissionInfo && css.linkActive)}
        href="#"
        data-intercom-target="MissionWindowNavMissionInfo"
      >
        <DroneQIcon size={20} color={selectedMissionWindowTab === MissionWindowTab.MissionInfo ? Gray170 : Gray100} />
        {MissionWindowTab.MissionInfo}
      </a>
    </nav>
  );
};
